import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectListData } from '../../actions/project';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { CLEAR_PROJECT_DROPDOWN_LIST_DATA } from '../../types/project';
import { useFormContext } from 'react-hook-form';

export default function Project({ name, label, onChange = () => { }, org_id, required = true, isMulti, org_check_required = true, readOnly, className = '', prefill = [] }) {
    const dispatch = useDispatch();
    const projectDropdownListData = useSelector((state) => state.project.projectDropdownListData);
    const isProjectDropDownListLoading = useSelector((state) => state.loading.isProjectDropDownListLoading);
    const methods = useFormContext();

    const getProjectList = ({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getProjectListData({ limit, page, query, dropdown: true, payload: { org_id } }));
    };

    const debouncedProjectSearchSearch = useCallback(debounce(getProjectList), []);

    useEffect(() => {
        let payload = {
            limit: 100,
            page: 1,
        }
        if (org_check_required) payload.org_id = org_id;
        getProjectList(payload);
    }, [org_id]);


    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_PROJECT_DROPDOWN_LIST_DATA });
        }
    }, [dispatch]);


    useEffect(() => {
        if (prefill.length > 0 && projectDropdownListData.length > 0) {
            const projects = projectDropdownListData.filter((project) => prefill.includes(project.value));
            if (isMulti && projects.length > 0) {
                methods.setValue(name, projects);
            } else if (projects && projects.length > 0) {
                methods.setValue(name, projects[0]);
            }
        }
    }, [projectDropdownListData, prefill]);

    return (
        <Select
            className={className}
            label={label}
            name={name}
            type={'dropdown'}
            options={projectDropdownListData}
            isLoading={isProjectDropDownListLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    let p = { query: event }
                    if (org_check_required) p.org_id = org_id;
                    debouncedProjectSearchSearch(p)
                }
            }}
            onChange={(event) => {
                onChange(event)
            }}
            required={required}
            isMulti={isMulti}
            readOnly={readOnly}
        />
    )
}
